import { NgStyle } from '@angular/common';
import { Component, Inject, input, ChangeDetectionStrategy } from '@angular/core';
import { CDN_URL } from '@maximizer/core/shared/domain';
import { UI_KENDO } from '@maximizer/core/shared/ui/kendo';
import {
  InitOnboardingDialog,
  OnboardingService,
  OnboardingStore,
} from '@maximizer/outlook/shared/data-access';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_DIALOG } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'maximizer-outlook-onboarding-celebration',
  template: ` <kendo-dialog [width]="275" [minHeight]="405">
    <button
      kendoButton
      id="outlook-onboarding-ui-celebration-closeIcon"
      themeColor="primary"
      fillMode="flat"
      iconClass="fa-icons icon-xmark icon-16"
      class="small absolute top-1 right-1"
      [attr.aria-label]="'outlook.buttons.close' | translate"
      (click)="onboardingService.quit()"
    ></button>
    <div
      class="confetti pt-23 bg-top bg-contain bg-no-repeat"
      [ngStyle]="{
        'background-image':
          'url(' + this.cdn + '/assets/images/outlook/welcome_confetti_50.png)',
      }"
    >
      <div class="px-8 flex flex-col gap-3">
        <p
          class="subtitle-1"
          [translate]="'outlook.onboarding.' + step() + '.title'"
        ></p>
        <p
          class="text-body"
          [translate]="'outlook.onboarding.' + step() + '.message1'"
        ></p>
        <p
          class="text-body"
          [innerHTML]="'outlook.onboarding.' + step() + '.message2' | translate"
        ></p>

        @if (step() === 'start') {
          <p
            class="text-body"
            [innerHTML]="'outlook.onboarding.start.message3' | translate"
          ></p>
          <div class="flex flex-col gap-2">
            <button
              kendoButton
              id="outlook-onboarding-ui-celebration-start"
              themeColor="primary"
              (click)="start()"
            >
              {{ 'outlook.buttons.start' | translate }}
            </button>
            <button
              kendoButton
              id="outlook-onboarding-ui-celebration-remindLater"
              themeColor="primary"
              fillMode="flat"
              (click)="remindLater()"
            >
              {{ 'outlook.buttons.remindLater' | translate }}
            </button>
          </div>
        } @else {
          <button
            kendoButton
            id="outlook-onboarding-ui-celebration-done"
            class="mt-32"
            themeColor="primary"
            fillMode="flat"
            (click)="onboardingService.finish()"
          >
            {{ 'outlook.buttons.done' | translate }}
          </button>
        }
      </div>
    </div>
  </kendo-dialog>`,
  styles: `
    a {
      color: blue;
    }
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    KENDO_BUTTON,
    KENDO_DIALOG,
    NgStyle,
    TranslateDirective,
    TranslatePipe,
    UI_KENDO,
  ],
})
export class CelebrationComponent {
  step = input<InitOnboardingDialog>('start');

  readonly userGuideUrl =
    'https://support.maximizer.com/hc/en-us/articles/29776800842253-Microsoft-Outlook-Integration-Getting-Started-Guide-Maximizer-AI-CRM-app-for-Outlook';

  constructor(
    @Inject(CDN_URL) public readonly cdn: string,
    public onboardingService: OnboardingService,
    public onboardingStore: OnboardingStore,
  ) {}

  start(): void {
    this.onboardingService.start();
  }

  remindLater(): void {
    this.onboardingService.remindLater();
  }
}
